import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/client.js';
import { useAuth } from '../auth/AuthContext.jsx';
import PasswordInput from '../components/PasswordInput.jsx';

export default function ChangePassword() {
  const { user, setUser, logout } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const forced = !!user?.must_change_password;

  async function onSubmit(e) {
    e.preventDefault();
    setErr(null);
    if (next !== confirm) { setErr('New passwords do not match'); return; }
    if (next.length < 12) { setErr('New password must be at least 12 characters'); return; }
    setBusy(true);
    try {
      await api.post('/auth/change-password', { current_password: current, new_password: next });
      setUser({ ...user, must_change_password: false });
      nav('/', { replace: true });
    } catch (e) {
      setErr(e?.response?.data?.error || 'Change password failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <div className="bg-navy h-2" />
      <div className="bg-crimson h-1" />
      <div className="flex-1 flex items-center justify-center px-4 py-10">
        <div className="w-full max-w-sm">
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold mt-2">Change Password</h1>
            <div className="rule-crimson mx-auto" />
            <p className="text-muted text-sm">
              {forced ? 'You must set a new password before continuing.' : 'Update your password.'}
            </p>
          </div>
          <form onSubmit={onSubmit} className="card p-6 space-y-4">
            <div>
              <label className="label">Current password</label>
              <PasswordInput value={current} onChange={e => setCurrent(e.target.value)}
                             required autoFocus />
            </div>
            <div>
              <label className="label">New password (min 12 chars)</label>
              <PasswordInput value={next} onChange={e => setNext(e.target.value)}
                             autoComplete="new-password" required minLength={12} />
            </div>
            <div>
              <label className="label">Confirm new password</label>
              <PasswordInput value={confirm} onChange={e => setConfirm(e.target.value)}
                             autoComplete="new-password" required minLength={12} />
            </div>
            {err && <div className="text-crimson text-sm">{err}</div>}
            <button type="submit" disabled={busy} className="btn-primary w-full">
              {busy ? 'Updating…' : 'Update password'}
            </button>
            {forced && (
              <button type="button" onClick={() => { logout(); nav('/login'); }}
                      className="text-sm text-muted underline w-full text-center">
                Sign out instead
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}
